/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Experience_Stopped_Ago_ShortInputs */

const en_us2_intake_why_experience_stopped_ago_short = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets how fast loads rise`)
};

const pt_br2_intake_why_experience_stopped_ago_short = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define a velocidade das cargas`)
};

const es_419_intake_why_experience_stopped_ago_short = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define qué tan rápido suben las cargas`)
};

const pt_pt2_intake_why_experience_stopped_ago_short = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define a velocidade das cargas`)
};

const fr_fr2_intake_why_experience_stopped_ago_short = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixe la vitesse de hausse des charges`)
};

const de_de2_intake_why_experience_stopped_ago_short = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestimmt, wie schnell Gewichte steigen`)
};

const it_it2_intake_why_experience_stopped_ago_short = /** @type {(inputs: Intake_Why_Experience_Stopped_Ago_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decide quanto salgono i carichi`)
};

/**
* | output |
* | --- |
* | "Sets how fast loads rise" |
*
* @param {Intake_Why_Experience_Stopped_Ago_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_experience_stopped_ago_short = /** @type {((inputs?: Intake_Why_Experience_Stopped_Ago_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Experience_Stopped_Ago_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_experience_stopped_ago_short(inputs)
	if (locale === "es-419") return es_419_intake_why_experience_stopped_ago_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_experience_stopped_ago_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_experience_stopped_ago_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_experience_stopped_ago_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_experience_stopped_ago_short(inputs)
	return en_us2_intake_why_experience_stopped_ago_short(inputs)
});
export { intake_why_experience_stopped_ago_short as "intake.why.experience_stopped_ago.short" }